import { createSlice, current } from '@reduxjs/toolkit';

// BroadcastChannel for multi-tab synchronization
let broadcastChannel = null;
if (typeof BroadcastChannel !== 'undefined') {
  broadcastChannel = new BroadcastChannel('task-unread-sync');
};

// BroadcastChannel helper functions
const broadcastToOtherTabs = (type, data) => {
  if (broadcastChannel) {
    const message = {
      type,
      data,
      timestamp: Date.now(),
      tabId: `tab-${Date.now()}-${Math.random()}`
    };
    broadcastChannel.postMessage(message);
    console.log('📡 Broadcasting to other tabs:', type, data);
  }
};

// uiSlice.js
const initialState = {
  isModalOpen: false,
  isLoading: false,
  isLoggedIn: false,
  selectedGroup: null,        // holds { id, name }
  isGroupSelected: false,
  readCountGroupChat: 0,
  // Chat UI state
  chatIconVisible: true,
  showChatbox: false,
  chatInfo: {
    unreadCounts: {},
    sender: null,
    receiver: null,
    latestMessage: {}
  },

  groupchatInfo: {
    unreadCounts: {},
    sender: null,
    receiver: null,
    latestMessage: {}
  },
  readCountDisscutions: {
    taskDiscussion: {
      // e.g. { taskId: unreadCount }
    }
  },

  // Typing indicators state
  typingIndicators: {
    // { userId: { senderName, isTyping, timestamp } }
  },
  
  // Task discussion typing indicators
  taskDiscussionTyping: {
    // { taskId: { userId: { senderName, isTyping, timestamp } } }
  },

  // Cross-tab advanced features
  activeTab: null,                    // Which tab is currently focused
  tabStates: {},                      // State of each tab
  navigationEvents: [],               // Recent navigation events
  draftMessages: {},                  // Cross-tab draft sync
  scrollPositions: {}                 // Sync scroll positions
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleModal: (state) => {
      state.isModalOpen = !state.isModalOpen;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroup = action.payload; // { id, name }
      state.isGroupSelected = true;
    },
    clearSelectedGroup: (state) => {
      state.selectedGroup = null;
      state.isGroupSelected = false;
    },

    setReadCount: (state, action) => {
      const { value, sender, receiver, latestMessage } = action.payload;
      //  console.log("setReadCount called with:", action.payload);
      // If the key exists at the top level

      if (!state.chatInfo.unreadCounts) {
        state.chatInfo.unreadCounts = {};
      }

      state.chatInfo.unreadCounts[sender] = value;

      state.chatInfo.latestMessage[sender] = latestMessage;
      if (sender !== undefined) {
        state.chatInfo.sender = sender;
      }

      if (receiver !== undefined) {
        state.chatInfo.receiver = receiver;
      }
    },
    updateUnreadCounts: (state, action) => {
      // action.payload = { groupId1: 3, groupId2: 5 }
      state.groupchatInfo.unreadCounts = {
        ...state.groupchatInfo.unreadCounts,
        ...action.payload, // merge new counts
      };
    },
    clearReadCount: (state, action) => {
      console.log("clearReadCountclearReadCountclearReadCount")

      if (action.payload?._id) {
        console.log(action.payload._id)
        const sender = action.payload._id
        state.chatInfo.unreadCounts[sender] = 0;
      }

    },
    setDiscussionUnreadCount: (state, action) => {
      console.log(action.payload)
      const key = action.payload.discussionId; // e.g. 'readCountGroupChat'
      if (key !== undefined) {
        state.readCountDisscutions.taskDiscussion[key] = action.payload;
        
        // 📡 Broadcast to other tabs
        broadcastToOtherTabs('UNREAD_COUNT_UPDATE', action.payload);
      }
    },
    // New action to sync from other tabs (doesn't broadcast to avoid loops)
    syncDiscussionUnreadCountFromBroadcast: (state, action) => {
      console.log('🔄 Syncing from another tab:', action.payload);
      const key = action.payload.discussionId;
      if (key !== undefined) {
        state.readCountDisscutions.taskDiscussion[key] = action.payload;
      }
    },

    clearReadCountDiscussion: (state, action) => {
      const discussionId = action.payload;

      console.log("=== CLEAR READ COUNT DEBUG START ===");
      console.log("Action Payload (discussionId):", discussionId);

      // Log entire state
      console.log("Full state:", JSON.parse(JSON.stringify(state)));

      // Log specifically readCountDisscutions
      if (!state.readCountDisscutions) {
        console.warn("⚠️ state.readCountDisscutions is UNDEFINED!");
      } else {
        console.log("Current state snapshot:", current(state.readCountDisscutions));

        if (!state.readCountDisscutions.taskDiscussion) {
          console.warn("⚠️ state.readCountDisscutions.taskDiscussion is UNDEFINED!");
        } else {
          console.log("✅ taskDiscussion keys:", Object.keys(state.readCountDisscutions.taskDiscussion));
          console.log("Value at discussionId:", state.readCountDisscutions.taskDiscussion[discussionId]);
        }
      }

      // Apply clearing if valid
      if (
        discussionId &&
        state.readCountDisscutions &&
        state.readCountDisscutions.taskDiscussion &&
        state.readCountDisscutions.taskDiscussion[discussionId] !== undefined
      ) {
        console.log(`✅ Clearing read count for discussionId: ${discussionId}`);
        state.readCountDisscutions.taskDiscussion[discussionId] = 0;
      } else {
        console.warn(`❌ Could not clear read count for discussionId: ${discussionId}`);
      }

      console.log("=== CLEAR READ COUNT DEBUG END ===");
    },
    clearGroupCount: (state, action) => {
      console.log("clearReadCountclearReadCountclearReadCount")
      console.log(state.groupchatInfo)
      console.log(current(state.groupchatInfo))
      console.log(action.payload)
      // console.log(state.,"state.action")

      if (action.payload) {
        console.log(action.payload)
        state.groupchatInfo.unreadCounts[action.payload] = 0
      }

    },

    // ===== TYPING INDICATORS =====
    setUserTyping: (state, action) => {
      const { userId, senderName, isTyping } = action.payload;
      console.log(`🔤 Redux: Setting typing for ${senderName} (${userId}): ${isTyping}`);
      
      if (isTyping) {
        state.typingIndicators[userId] = {
          senderName,
          isTyping: true,
          timestamp: Date.now()
        };
      } else {
        delete state.typingIndicators[userId];
      }
    },

    clearTypingIndicator: (state, action) => {
      const { userId } = action.payload;
      delete state.typingIndicators[userId];
    },

    clearAllTyping: (state) => {
      state.typingIndicators = {};
    },

    // ===== TASK DISCUSSION TYPING INDICATORS =====
    setTaskDiscussionTyping: (state, action) => {
      const { taskId, userId, senderName, isTyping } = action.payload;
      console.log(`🔤 Redux: Setting task discussion typing for ${senderName} (${userId}) in task ${taskId}: ${isTyping}`);
      
      if (!state.taskDiscussionTyping[taskId]) {
        state.taskDiscussionTyping[taskId] = {};
      }
      
      if (isTyping) {
        state.taskDiscussionTyping[taskId][userId] = {
          senderName,
          isTyping: true,
          timestamp: Date.now()
        };
      } else {
        delete state.taskDiscussionTyping[taskId][userId];
        
        // Clean up empty task objects
        if (Object.keys(state.taskDiscussionTyping[taskId]).length === 0) {
          delete state.taskDiscussionTyping[taskId];
        }
      }
    },

    clearTaskDiscussionTyping: (state, action) => {
      const { taskId, userId } = action.payload;
      if (state.taskDiscussionTyping[taskId]) {
        delete state.taskDiscussionTyping[taskId][userId];
        
        if (Object.keys(state.taskDiscussionTyping[taskId]).length === 0) {
          delete state.taskDiscussionTyping[taskId];
        }
      }
    },

    clearAllTaskDiscussionTyping: (state) => {
      state.taskDiscussionTyping = {};
    },

    // ===== CROSS-TAB ADVANCED FEATURES =====
    setActiveTabId: (state, action) => {
      state.activeTab = action.payload; // e.g., 'tab-xyz'
      broadcastToOtherTabs('FOCUS_CHANGED', { tabId: state.activeTab });
    },

    syncActiveTabFromBroadcast: (state, action) => {
      state.activeTab = action.payload?.tabId || null;
    },

    broadcastNavigation: (state, action) => {
      // action.payload: { type: 'TO_TASK'|'TO_CHAT', params: {...} }
      const evt = { ...action.payload, at: Date.now() };
      state.navigationEvents.push(evt);
      broadcastToOtherTabs('NAVIGATE', evt);
    },

    syncNavigationFromBroadcast: (state, action) => {
      const evt = { ...action.payload, at: Date.now() };
      state.navigationEvents.push(evt);
    },

    saveDraft: (state, action) => {
      // action.payload: { key, text }
      const { key, text } = action.payload;
      state.draftMessages[key] = { text, at: Date.now() };
      broadcastToOtherTabs('DRAFT_UPDATE', { key, text });
    },

    syncDraftFromBroadcast: (state, action) => {
      const { key, text } = action.payload;
      state.draftMessages[key] = { text, at: Date.now() };
    },

    saveScrollPosition: (state, action) => {
      // action.payload: { key, y }
      const { key, y } = action.payload;
      state.scrollPositions[key] = y;
      broadcastToOtherTabs('SCROLL_SYNC', { key, y });
    },

    syncScrollFromBroadcast: (state, action) => {
      const { key, y } = action.payload;
      state.scrollPositions[key] = y;
    },

    // ===== CHAT UI MANAGEMENT =====
    setChatIconVisible: (state, action) => {
      state.chatIconVisible = action.payload;
      console.log(`📱 Redux: ChatIcon visibility set to: ${action.payload}`);
    },

    toggleChatIconVisible: (state) => {
      state.chatIconVisible = !state.chatIconVisible;
      console.log(`📱 Redux: ChatIcon visibility toggled to: ${state.chatIconVisible}`);
    },

    setShowChatbox: (state, action) => {
      state.showChatbox = action.payload;
      console.log(`💬 Redux: Chatbox visibility set to: ${action.payload}`);
      
      // Keep ChatIcon visible regardless of chatbox state
      // Don't change chatIconVisible here
    },

    toggleChatbox: (state) => {
      state.showChatbox = !state.showChatbox;
      console.log(`💬 Redux: Chatbox visibility toggled to: ${state.showChatbox}`);
      
      // Keep ChatIcon visible regardless of chatbox state
      // Don't change chatIconVisible here
    },

    hideChatIconOnRoute: (state, action) => {
      const { route } = action.payload;
      // Hide chat icon on specific routes
      const chatRoutes = ['/chatapp', '/chat', '/full-chat'];
      const shouldHideOnRoute = chatRoutes.includes(route);
      
      // Set visibility based on route - hide on chat routes, show on others
      state.chatIconVisible = !shouldHideOnRoute;
      console.log(`📱 Redux: Route ${route} - ChatIcon visible: ${state.chatIconVisible}`);
    }

    // state.readCountDisscutions.taskDiscussion[key] = 
  }





});

export const {
  toggleModal,
  setLoading,
  setLoggedIn,
  setSelectedGroup,
  clearSelectedGroup,
  setReadCount,
  clearReadCount,
  clearGroupCount,
  updateUnreadCounts,
  setDiscussionUnreadCount,
  syncDiscussionUnreadCountFromBroadcast,
  clearReadCountDiscussion,
  setUserTyping,
  clearTypingIndicator,
  clearAllTyping,
  setTaskDiscussionTyping,
  clearTaskDiscussionTyping,
  clearAllTaskDiscussionTyping,
  // Advanced cross-tab features
  setActiveTabId,
  syncActiveTabFromBroadcast,
  broadcastNavigation,
  syncNavigationFromBroadcast,
  saveDraft,
  syncDraftFromBroadcast,
  saveScrollPosition,
  syncScrollFromBroadcast,
  // Chat UI actions
  setChatIconVisible,
  toggleChatIconVisible,
  setShowChatbox,
  toggleChatbox,
  hideChatIconOnRoute
} = uiSlice.actions;

// BroadcastChannel listener setup
export const setupBroadcastListener = (store) => {
  if (broadcastChannel) {
    broadcastChannel.onmessage = (event) => {
      const { type, data, timestamp } = event.data;
      
      console.log('📡 Received broadcast message:', type, data);
      
      switch (type) {
        case 'UNREAD_COUNT_UPDATE':
          // Use the sync action to avoid broadcast loops
          store.dispatch(syncDiscussionUnreadCountFromBroadcast(data));
          break;
        case 'FOCUS_CHANGED':
          store.dispatch(syncActiveTabFromBroadcast(data));
          break;
        case 'NAVIGATE':
          store.dispatch(syncNavigationFromBroadcast(data));
          break;
        case 'DRAFT_UPDATE':
          store.dispatch(syncDraftFromBroadcast(data));
          break;
        case 'SCROLL_SYNC':
          store.dispatch(syncScrollFromBroadcast(data));
          break;
        default:
          console.warn('Unknown broadcast message type:', type);
      }
    };
    
    console.log('📡 BroadcastChannel listener setup complete');
  }
};

// Cleanup function
export const cleanupBroadcast = () => {
  if (broadcastChannel) {
    broadcastChannel.close();
    broadcastChannel = null;
    console.log('🔌 BroadcastChannel closed');
  }
};

export default uiSlice.reducer;

// Reducer
